/**
 * Employee Web — `/me/overview` tab route.
 *
 * Phase 03 Plan 03-12b Task 1. Identity summary: Avatar + bilingual names +
 * employeeCode + branch + position + hire date (via CalendarDate).
 * Read-only; edit lives under /me/personal.
 *
 * Phase 04 Plan 04-04 Task 4 (EW-13): mounts <EosPreviewCard> below the
 * identity summary. The card self-gates on
 * `tenantSettings.eosVisibility.showToEmployee` (EMP-16, post-CC-36 wire
 * shape) — renders nothing when the tenant flag is off, so this route stays
 * functional for all tenants regardless of configuration.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { OverviewTab, EosPreviewCard } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/overview")({
  staticData: { breadcrumb: { labelKey: "me-profile:tabs.overview" } },
  component: OverviewTabRoute,
});

function OverviewTabRoute(): JSX.Element {
  return (
    <div className="flex flex-col gap-lg">
      <OverviewTab />
      <EosPreviewCard />
    </div>
  );
}
